import { UPDATE_LAST_SITE_ACTIVITY_DATE, PERSONALIZATION_API_KEY } from './constants';

const updateLastSiteActivityDate = async (email: string) => {
  const url = `${UPDATE_LAST_SITE_ACTIVITY_DATE}${email}`;
  const response = await fetch(url, {
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
};

export default updateLastSiteActivityDate;
